import { motion } from 'framer-motion';

export function SJChatStreamingIndicator({ content }: { content: string }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="flex justify-start"
    >
      <div className="max-w-[85%] rounded-[16px] bg-[var(--sj-surface-muted)] px-4 py-3 text-[var(--sj-text-primary)] md:max-w-[70%]">
        {content ? (
          <div className="text-sm leading-relaxed whitespace-pre-wrap">
            {content}
            <span className="inline-block w-1.5 h-4 ml-0.5 bg-[var(--sj-text-primary)] animate-pulse rounded-sm" />
          </div>
        ) : (
          <div className="flex items-center gap-1.5 py-1">
            <span className="h-2 w-2 rounded-full bg-[var(--sj-text-muted)] animate-[bounce_1s_infinite_0ms]" />
            <span className="h-2 w-2 rounded-full bg-[var(--sj-text-muted)] animate-[bounce_1s_infinite_150ms]" />
            <span className="h-2 w-2 rounded-full bg-[var(--sj-text-muted)] animate-[bounce_1s_infinite_300ms]" />
          </div>
        )}
      </div>
    </motion.div>
  );
}
